// @flow

import { type UserInputValidationError } from '@tectonics/prs/validation';

export function validateSouthAfricanZipcode(zipcodeValue: string): ?UserInputValidationError {
  if (!zipcodeValue || zipcodeValue.trim() === '')
    return { id: 'empty' };
  else if (!/^\d{4}$/.test(zipcodeValue))
    return { id: 'invalid-pattern' };
}
